module.exports = __webpack_public_path__ + "img/inputsearch copy.ac5104d4.svg";